import React,{useState, useEffect} from "react";
import SearchFilter from "../../../components/search-filter";
// import config from "../../../config";
import client from "../../../clients";
import { getAllParameters } from "../../parameters/helper/api";
import { isAuthenticated } from "../../../auth";
import { calculateBMIKgFeet, formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
import { getAllFitnessTestPlanners } from "../../../features/planner/helper/api";
import { createFitnessTestReport,getAllParentFitnessTestReports,getChildFitnessTestReports,getParentFitnessTestReport } from "../helper/api";
import Toast from "../../../lib/toast";
import NoDataFoundImg from '../../../assets/no_data.png';

const FitnessTest = (props) => {
  const pageSize = {
    planner: 30
  };
  const [pageCount, setPageCount] = useState({
    planner: 0
  });
  var [pageNo, setPageNo] = useState({
    planner: 0
  })
  const [total, setTotal] = useState({
    planner: 0
  });
  const {user, token} = isAuthenticated();
  const [memberInfo, setMemberInfo] = useState("");
  const [allGoals, setAllGoals] = useState([]);
  const [currentElementId, setCurrentElementId] = useState("");
  const [achievements, setAchievements] = useState([]);
  const [allFitnessTestPlanners, setAllFitnessTestPlanners] = useState([]);
  const [selectedFitnessPlanner, setSelectFitnessPlanner] = useState("");
  const [goalType, setGoalType] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [selectedPlannerIndex, setSelectedPlannerIndex] = useState(-1);
  const [isFitnessPlannerSelected, setFitnessPlannerSelected] = useState(false);
  const [fitnessMeasurementGoal, setFitnessMeasurementGoal] = useState({
    chest: "",
    thighCircumference: "",
    midArmCircumference: "",
    foreArmCircumference: "",
    upperArmCircumference: "",
    waist: ""
  });
  const [parentReport, setParentReport] = useState("");
  const [latestChildReport, setLatestChildReport] = useState("");
  const [isButtonLock, setButtonLock] = useState(true);
  const [isGoalAvailable, setGoalAvailable] = useState(true);
  const [isSavingReport, setSavingReport] = useState(false);
  const [isFitnessPlannerLoader, setFitnessPlannerLoader] = useState(false);

  const [fitnessTest, setFitnessTest] = useState({
    reportDate: new Date().toISOString(),
    goal: {
      goalId: "",
      goalName: "",
      goalDisplayName: "",
      goalStatus: ""
    },
    weight:{
      value: "",
      unit: "kg"
    },
    height:{
      value: "",
      unit: "ft"
    },
    bmi: {
      value: "",
      bodyType: ""
    },
    images: [],
    fitnessMeasurement: {
      chest: "",
      thighCircumference: "",
      midArmCircumference: "",
      foreArmCircumference: "",
      upperArmCircumference: "",
      waist: ""
    },
    selectedFitnessPlanner: {
      plannerId: "",
      plannerName: ""
    },
    fitnessTests: [],
    parentFitnessTestReportId: "",
    goalAchieved: false
  });

  const [isAchievementListOpen, setAchievementListOpen] = useState(false);
  const [fitnessTestDataType, setFitnessTestDataType] = useState("fitness-measurement");

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);

    if (event) {
      let interval = setInterval(() => {
        let element = document.getElementById(id) ? document.getElementById(id) : event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }

    // if(id == "choose-goal"){
    //   setAchievementListOpen(!isAchievementListOpen)
    // }
    
  }

  const handleChange = (index) => event => {
    if(currentElementId == "goal-display-name"){

      console.log(event.target.value);
      
      setFitnessTest(prev => ({
        ...prev,
        goal: {
          ...prev.goal,
          goalDisplayName: event.target.value
        }
      }))
    }
    
    if(currentElementId == "user-weight"){
      setFitnessTest(prev => ({
        ...prev,
        weight: {
          ...prev.weight,
          value: event.target.value
        }
      }))
    }

    if(currentElementId == "user-height"){
      setFitnessTest(prev => ({
        ...prev,
        height: {
          ...prev.height,
          value: event.target.value
        }
      }))
    }

    // Measurement
    if(currentElementId == "chest-current"){
      setFitnessTest(prev => ({
        ...prev,
        fitnessMeasurement: {
          ...prev.fitnessMeasurement,
          chest: event.target.value
        } 
      }))
    }

    if(currentElementId == "chest-goal"){
      setFitnessMeasurementGoal(prev => ({
        ...prev,
        chest: event.target.value 
      }))
    }

    if(currentElementId == "thigh-circumference-current"){
      setFitnessTest(prev => ({
        ...prev,
        fitnessMeasurement: {
          ...prev.fitnessMeasurement,
          thighCircumference: event.target.value
        } 
      }))
    }

    if(currentElementId == "thigh-circumference-goal"){
      setFitnessMeasurementGoal(prev => ({
        ...prev,
        thighCircumference: event.target.value 
      }))
    }

    if(currentElementId == "mid-arm-circumference-current"){
      setFitnessTest(prev => ({
        ...prev,
        fitnessMeasurement: {
          ...prev.fitnessMeasurement,
          midArmCircumference: event.target.value
        } 
      }))
    }

    if(currentElementId == "mid-arm-circumference-goal"){
      setFitnessMeasurementGoal(prev => ({
        ...prev,
        midArmCircumference: event.target.value 
      }))
    }

    if(currentElementId == "fore-arm-circumference-current"){
      setFitnessTest(prev => ({
        ...prev,
        fitnessMeasurement: {
          ...prev.fitnessMeasurement,
          foreArmCircumference: event.target.value
        } 
      }))
    }

    if(currentElementId == "fore-arm-circumference-goal"){
      setFitnessMeasurementGoal(prev => ({
        ...prev,
        foreArmCircumference: event.target.value 
      }))
    }

    if(currentElementId == "upper-arm-circumference-current"){
      setFitnessTest(prev => ({
        ...prev,
        fitnessMeasurement: {
          ...prev.fitnessMeasurement,
          upperArmCircumference: event.target.value
        } 
      }))
    }

    if(currentElementId == "upper-arm-circumference-goal"){
      setFitnessMeasurementGoal(prev => ({
        ...prev,
        upperArmCircumference: event.target.value 
      }))
    }

    if(currentElementId == "waist-current"){
      setFitnessTest(prev => ({
        ...prev,
        fitnessMeasurement: {
          ...prev.fitnessMeasurement,
          waist: event.target.value
        } 
      }))
    }

    if(currentElementId == "waist-goal"){
      setFitnessMeasurementGoal(prev => ({
        ...prev,
        waist: event.target.value 
      }))
    }
    // Fitness Goal
    if(currentElementId.includes("fp-achievement")){
      console.log(event.target.value)
      setFitnessTest(prev => ({
        ...prev,
        fitnessTests: prev.fitnessTests.map((item, i) => 
          i == index ? {...item, value : event.target.value} : item
        )

      }))
    }

    if(currentElementId.includes("fp-goal") ){
      setFitnessTest(prev => ({
        ...prev,
        fitnessTests: prev.fitnessTests.map((item, i) => 
          i == index ? {...item, goal : event.target.value} : item
        )
      }))
    }
  }

  const handleUserSearchKey = (searchedData) => {
    setSearchKey(searchedData)
  }

  const handleFitnessType = (type) => {
    setFitnessTestDataType(type);
  }

  const handleSelectFitnessGoal = async(goalInfo, type) => {
    
    setGoalType(type);
    setFitnessTest(prev => ({
      ...prev,
      goal: {
        ...prev.goal,
        goalId: type == "new-goal" ? goalInfo._id : goalInfo.goalId,
        goalName: type == "new-goal" ? goalInfo.name : goalInfo.goalName,
        goalDisplayName : type == "new-goal" ? goalInfo.name : goalInfo.goalDisplayName,
        goalStatus: type == "new-goal" ? "new-goal" : "active"
      }
    }))

    console.log(goalInfo)

    if(goalInfo.goalStatus == "active"){
      let parentQuery = {
        memberId: props.memberInfo._id,
        parentId: goalInfo.goalId
      }

      let childQuery = {
        memberId: props.memberInfo._id,
        parentId: goalInfo._id
      };
            
      startLoader();

      try{
        let response = await getAllParentFitnessTestReports(user._id, token, parentQuery);

        if(!response){
          console.log(response.error)
        }else{
          setParentReport(response);
          console.log(response);


          try{
            let reports = await getChildFitnessTestReports(user._id, token, childQuery);
    
            if(!reports){
              console.log(reports.error)
              console.log(reports)
            }else{
              if(reports.length > 0){
                setLatestChildReport(reports[0])
              }
            }
          }catch(error){
            console.log(error);
            stopLoader();
          }

          stopLoader();

        }
        stopLoader();
      }catch(error){
        console.log(error)
      }
    }
    
  }

  const handleRemoveGoal = (goalInfo) => {
    setGoalType("");
    setFitnessTest(prev => ({
      ...prev,
      goal: {
        ...prev.goal,
        goalId: "",
        goalName: ""
      }
    }))
  }

  const handleAddImage = (e) => {
    const files = Array.from(e.target.files);
    setFitnessTest((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
  };

  const handleDeleteImage = (index) => {
    setFitnessTest(prev => ({
        ...prev,
        images: prev.images.filter((_, i) => i !== index)
      }
    ))
  }

  const handleSelectFitnessTest = (data, index) => {
    setSelectFitnessPlanner(data);
    setSelectedPlannerIndex(index);

    if(data && data.exercises && data.exercises.length > 0){
      console.log(data)

      setFitnessTest(prev => ({
        ...prev,
        selectedFitnessPlanner: {
          ...prev.selectedFitnessPlanner,
          plannerId: data._id,
          plannerName: data.name
        }
      }))

      const fitnessTestArr = data.exercises.map(ex => ({
        exerciseName: ex.additionalContentDetails?.exerciseName || "",
        exerciseUnit: ex.additionalContentDetails?.unit || "",
        value: "",
        goal: "",
        disabled: false
      }));

      setFitnessTest(prev => ({
        ...prev,
        fitnessTests: fitnessTestArr
      }));
      
    }
  }

  const handleUnselectFitnessPlanner = () => {
    setFitnessPlannerSelected(false);
  }

  const handleSelectFitnessPlanner = () => {
    setFitnessPlannerSelected(true);
  }

  const SaveFitnessTestReport=async event=>{
    event.preventDefault();
    try{

      setButtonLock(true);

      let formData=new FormData();
      if(fitnessTest.parentFitnessTestReportId){
        formData.set('parentFitnessTestReportId', fitnessTest.parentFitnessTestReportId);
      }
      formData.set('goal',JSON.stringify(fitnessTest.goal));
      await Promise.all(fitnessTest.images.filter(data=>!data.isCloudFile).map(file=>{
        formData.append('files',file);
      }));
      let exerciseReports=await Promise.all(fitnessTest.fitnessTests.filter(data=>!data.isDisabled).map(data=>{
        delete data.disabled;
        return data;
      }));
      formData.set('exerciseReports',JSON.stringify(exerciseReports));
      let measurement={
        achievement:{
          chest: fitnessTest.fitnessMeasurement.chest,
          thigh_circumference:fitnessTest.fitnessMeasurement.thighCircumference,
          mid_arm_circumference:fitnessTest.fitnessMeasurement.midArmCircumference,
          fore_arm_circumference:fitnessTest.fitnessMeasurement.foreArmCircumference,
          upper_arm_circumference:fitnessTest.fitnessMeasurement.upperArmCircumference,
          waist:fitnessTest.fitnessMeasurement.chest,
          hip:fitnessTest.fitnessMeasurement.hip,
          calf:fitnessTest.fitnessMeasurement.calf
        },
        goal:{
          chest:fitnessMeasurementGoal.chest,
          thigh_circumference:fitnessMeasurementGoal.thighCircumference,
          mid_arm_circumference:fitnessMeasurementGoal.midArmCircumference,
          fore_arm_circumference:fitnessMeasurementGoal.foreArmCircumference,
          upper_arm_circumference:fitnessMeasurementGoal.upperArmCircumference,
          waist:fitnessMeasurementGoal.chest,
          hip:fitnessMeasurementGoal.hip,
          calf:fitnessMeasurementGoal.calf
        }
      };
      formData.set('measurement',JSON.stringify(measurement));
      formData.set('weight',JSON.stringify(fitnessTest.weight));
      formData.set('height',JSON.stringify(fitnessTest.height));
      formData.set('bodyComposition',JSON.stringify(fitnessTest.bmi));
      formData.set('selectedFitnessPlanner',JSON.stringify(fitnessTest.selectedFitnessPlanner));
      if(fitnessTest.reportDate){ 
        formData.set("reportDate",fitnessTest.reportDate);
        formData.set("reportDateString",formatDateTime(fitnessTest.reportDate));
      }
      formData.set('goalAchieved',fitnessTest.goalAchieved);
   
      let response=await createFitnessTestReport(user._id,token,memberInfo._id,formData);
      if(!response) throw new Error("Got null response") && (setButtonLock(false));
      if(response.error){
        setButtonLock(false);
        console.error(response);
      }else{
        console.log("Report Submitted");
        // handle success
        if(props.toggleFitnessTestModal) props.toggleFitnessTestModal();

         new Toast({
          message:"Report Submitted Successfully",
          type:"success",
          duration:3000
        })

        setButtonLock(false);

        if(props.actionType == "parent"){
          window.location.replace(`/member/${props.memberInfo._id}`);
        }
      
      }
    }catch(error){
      console.error(error);

      setButtonLock(false);
      setSavingReport(false);
    }
  }

  const handleFitnessPlannerScroll = async event => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      console.log(event.target.clientHeight)
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo.member < pageCount.member && !isFitnessPlannerLoader) {
        if (pageNo.planner < pageCount.planner) {
          pageNo.planner = pageNo.planner + 1;
          setPageNo({
            ...pageNo
          })
          setFitnessPlannerLoader(true);
          await GetAllFitnessPlanner();
          setFitnessPlannerLoader(false)
        }
      }
    } catch (error) {
      setFitnessPlannerLoader(false)
    }
  }

  const GetAllFitnessPlanner = async(isReUpdatePlanner) => {
     try{
      let params={
        pageNo: pageNo.planner,
        pageSize: pageSize.planner
      };
      if (searchKey) params.q = searchKey;
      params.activationStatus = "activate";
      let responses = await getAllFitnessTestPlanners(user._id,token,params);

      if (!responses.error) {
        await Promise.all(responses.map(async response => {
          await Promise.all(response.exercises.map(async exercise=>{
            if(!exercise.isAdditionalContent && exercise.contentId){
                let content=await response.contents.find(d=>d._id == exercise.contentId);
                if(content) exercise.content={
                    ...content
                };
            }
          }))
        }));
        if (isReUpdatePlanner) setAllFitnessTestPlanners(responses);
        else setAllFitnessTestPlanners([...allFitnessTestPlanners, ...responses]);
        console.log(responses);
      };
    } catch (error) {

    }
  }

  const toggleGoalAchievement = () => {
    setFitnessTest(prev => ({
      ...prev,
      goalAchieved: !prev.goalAchieved
    }))
  }

useEffect(() => {
  const m = fitnessTest?.fitnessMeasurement || {};
  const g = fitnessMeasurementGoal || {};
  const goal = fitnessTest?.goal || {};
  const w = fitnessTest?.weight?.value;
  const h = fitnessTest?.height?.value;
  const tests = Array.isArray(fitnessTest?.fitnessTests) ? fitnessTest.fitnessTests : [];

  const hasAnyMeasurementPair = [
    "chest",
    "thighCircumference",
    "midArmCircumference",
    "foreArmCircumference",
    "upperArmCircumference",
    "hip",
    "calf",
  ].some(key => m[key] && g[key]);

  // ✅ All tests must have value & goal
  const allTestsFilled = tests.every(t => t.value && t.goal);

  const canUnlock =
    hasAnyMeasurementPair &&
    goal.goalName &&
    goal.goalDisplayName &&
    w &&
    h &&
    allTestsFilled;

  setButtonLock(!canUnlock);
}, [fitnessTest, fitnessMeasurementGoal]);


  useEffect(async() => {
    if(fitnessTest.goal.goalId != ""){
      let query = {
        goalId: fitnessTest.goal.goalId,
        memberId: memberInfo._id
      };
      try{
        let response = await getParentFitnessTestReport(user._id, token, query);
        if(response.error){
          console.error(response.error);
        }else{
          console.log(response);
          setFitnessTest(prev => ({
            ...prev,
            parentFitnessTestReportId: response._id
          }))
        }
      }catch(error){
        console.log(error)
      }
    }
  },[fitnessTest.goal.goalId && memberInfo._id]);

  useEffect(() => {
    if(fitnessTest.weight != "" && fitnessTest.height != ""){
      calculateBMIKgFeet(fitnessTest.weight.value, fitnessTest.height.value)
      // console.log(calculateBMIKgFeet(fitnessTest.weight, fitnessTest.height).bmi, calculateBMIKgFeet(fitnessTest.weight, fitnessTest.height).status);
      setFitnessTest(prev => ({
        ...prev,
        bmi: {
          ...prev.bmi,
          value: calculateBMIKgFeet(fitnessTest.weight.value, fitnessTest.height.value).bmi,
          bodyType: calculateBMIKgFeet(fitnessTest.weight.value, fitnessTest.height.value).status 
        }
      }))
    }
  },[fitnessTest.weight.value, fitnessTest.height.value]);

  useEffect(() => {

    if(parentReport != ""){

      setFitnessTest(prev => ({
        ...prev,
        parentFitnessTestReportId: parentReport._id,
        goal: {
          ...prev.goal,
          goalName: parentReport.goal.goalName,
          goalDisplayName: parentReport.goal.goalDisplayName,
          goalId: parentReport.goal.goalId,
          goalStatus: parentReport.goal.goalStatus
        },
        selectedFitnessPlanner: {
          ...prev.selectedFitnessPlanner,
          plannerId: parentReport.selectedFitnessPlanner.plannerId,
          plannerName: parentReport.selectedFitnessPlanner.plannerName
        },
        weight: {
          ...prev.bmi,
          value: latestChildReport.weight.current.value,
        },
        height: {
          ...prev.height,
          value: latestChildReport.height.current.value
        }
      }))

      const fitnessTestArr = latestChildReport.exerciseReports.map(ex => ({
        exerciseName: ex.exerciseName ? ex.exerciseName : "NA",
        exerciseUnit: ex.exerciseUnit ? ex.exerciseUnit : "NA",
        value: "",
        goal: ex.value,
        disabled: false
      }));

      setFitnessTest(prev => ({
        ...prev,
        fitnessTests: fitnessTestArr
      }));

      setFitnessMeasurementGoal(prev => ({
        ...prev,
        chest: latestChildReport.measurement.goal.chest,
        thighCircumference: latestChildReport.measurement.goal.thigh_circumference,
        midArmCircumference: latestChildReport.measurement.goal.mid_arm_circumference,
        foreArmCircumference: latestChildReport.measurement.goal.fore_arm_circumference,
        upperArmCircumference: latestChildReport.measurement.goal.upper_arm_circumference,
        waist: latestChildReport.measurement.goal.waist
      }));

      setFitnessPlannerSelected(true);
    }
  },[parentReport && latestChildReport])


  useEffect(()=>{
    if(props.parentReport){
      setParentReport(props.parentReport);
    }
    if(props.latestChildReport){
      setLatestChildReport(props.latestChildReport)
    }
  },[props])

  useEffect(() => {
    if(props.memberInfo){
      setMemberInfo(props.memberInfo);
    }
  },[props])

  useEffect(async() => {
    GetAllFitnessPlanner(true);
  },[props.actionType == "parent"])

  useEffect(async() => {
    try {
      let params = {
        noLimit: "noLimit",
        type: "member-goal"
      };
      let response = await getAllParameters(user._id, token, params);

      setAllGoals(response);

    } catch (error) {
    
    }
  },[props]);


  return(
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div  className={`${window.innerWidth > 767 ? "fitness-test-modal flex-item" : "w-full h-full"}`}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <p className="flex-item fs-18 font-weight-600 color-white m-l-5">Fitness Test</p>
              <div onClick={props.toggleFitnessTestModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        {
          props.actionType === "parent" && memberInfo.memberGoal &&  allGoals.filter(data=>!(memberInfo.memberGoal.findIndex(data2=>data2.goalName == data.name)!=-1)).length == 0 ? (            
            <>
            
              <div className="w-full d-flex" style={{borderRadius:"12px", padding:"12px"}}>
                <div className="flex-item margin-auto" style={{justifyContent:"center",textAlign:"center"}}>
                  {
                    memberInfo.user && memberInfo.user.length > 0 && [
                      <div className="d-flex flex-item m-b-12 m-t-20 margin-auto" style={{background:"#5d883c",width:"80px", height:"80px", borderRadius:"100%"}}>
                        {
                          memberInfo.user[0].profileID ? (
                            <img className="flex-item w-full h-full d-flex" style={{borderRadius:"100%"}} src={`${client.config.API_URL}/image/file/${memberInfo.user[0].profileID}/auto/auto/70?${Date.now()}`} />
                          ) : (
                            <p className='flex-item margin-auto font-weight-600 fs-30' style={{ color: '#ffffff', margin: '0 auto' }}>{`${memberInfo.userInfo.name}`.trim()[0]}</p>
                          )
                        }
                      </div>,
                      <p className="flex-item fs-16 font-weight-700 margin-auto" style={{lineHeight:"20px"}}>{memberInfo.userInfo && memberInfo.userInfo.name ? memberInfo.userInfo.name : ""}</p>,
                      <p className="flex-item fs-12 font-weight-400 margin-auto m-t-4" style={{lineHeight:"14px"}}>{memberInfo.userInfo && memberInfo.userInfo.phone ? memberInfo.userInfo.phone : ""}</p>
                    ]
                  }
                </div>
              </div>
              <div className="d-flex" style={{height:"60%", width:"100%"}}>
                <div className="flex-item margin-auto" style={{width:"80%", textAlign:"center"}}>
                  <img className="flex-item" style={{width:"100%"}} src={NoDataFoundImg} />
                  <p className="m-t-20 fs-14 color-dark-blue font-weight-700" style={{lineHeight:"18px"}}>Oops no new goals found for fitness test !!<br/>Please, go to user profile & complete the existing goals</p>
                </div>
              </div>
            </>
          ) : (
            <>
            {/* ()=>fitnessTestDataType == "fitness-test" &&  */}
            <div id="container" onScroll={handleFitnessPlannerScroll} className='progress-bar-scroll-container w-full m-b-12 p-l-12 p-t-12 p-r-12' style={{height: window.innerWidth > 767 ? "83%" : "100%", paddingBottom: window.innerWidth < 768 && "100px", overflowY:"auto"}}> 
              <div className="flex-item w-full d-flex" style={{borderRadius:"12px", padding:"8px 0px"}}>
                {
                  memberInfo.user && memberInfo.user.length > 0 && (
                    <div className="selected-fitness-test-user flex-item d-flex" style={{background:"#5d883c"}}>
                      {
                        memberInfo.user[0].profileID ? (
                          <img className="flex-item w-full h-full d-flex" src={`${client.config.API_URL}/image/file/${memberInfo.user[0].profileID}/auto/auto/70?${Date.now()}`} />
                        ) : (
                          <p className='flex-item margin-auto font-weight-600 fs-20' style={{ color: '#ffffff', margin: '0 auto' }}>{`${memberInfo.userInfo.name}`.trim()[0]}</p>
                        )
                      }
                    </div>
                  )
                }
                <div className="flex-item m-l-12">
                  <p className="flex-item fs-16 font-weight-700" style={{lineHeight:"20px"}}>{memberInfo.userInfo && memberInfo.userInfo.name ? memberInfo.userInfo.name : ""}</p>
                  <p className="flex-item fs-12 font-weight-400 m-t-4" style={{lineHeight:"14px"}}>{memberInfo.userInfo && memberInfo.userInfo.phone ? "+91" + memberInfo.userInfo.phone : ""}</p>
                </div>
              </div>

              {
                parentReport != "" ? (
                  <div className="w-full m-t-16">
                    <p className="flex-item fs-16 font-weight-700 m-b-12">Goal - <span className="color-dark-blue">{fitnessTest.goal.goalName}</span></p>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('goal-display-name')} className={`${(currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "1px solid var(--darkBlue)" : "", width: "100%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "10px" : "14px", color: (currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Goal Display Name</p>
                        </div>
                        <div className={`${(currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "active-input-field w-full" : "inactive-input-field"} space-between d-flex`} style={{width:"95%", marginLeft:"-2px", marginTop:"16px"}}>
                          <input id="goal-display-name" onChange={handleChange("")} value={fitnessTest.goal.goalDisplayName} style={{color: "#2b2b2b", width:"90%"}} type="text" placeholder='Enter Goal Name' disabled={true} />
                          <svg style={{marginTop:"-8px"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.616 21C6.168 21 5.78667 20.8427 5.472 20.528C5.15733 20.2133 5 19.8323 5 19.385V10.615C5 10.1683 5.15733 9.78733 5.472 9.472C5.78667 9.15733 6.168 9 6.616 9H8V7C8 5.886 8.38833 4.941 9.165 4.165C9.941 3.38833 10.886 3 12 3C13.114 3 14.0593 3.38833 14.836 4.165C15.6127 4.94167 16.0007 5.88667 16 7V9H17.385C17.8317 9 18.2127 9.15733 18.528 9.472C18.8427 9.78667 19 10.168 19 10.616V19.385C19 19.8317 18.8427 20.2127 18.528 20.528C18.2133 20.8427 17.8323 21 17.385 21H6.616ZM6.616 20H17.385C17.5643 20 17.7117 19.9423 17.827 19.827C17.9423 19.7117 18 19.5643 18 19.385V10.615C18 10.4357 17.9423 10.2883 17.827 10.173C17.7117 10.0577 17.5643 10 17.385 10H6.615C6.43567 10 6.28833 10.0577 6.173 10.173C6.05767 10.2883 6 10.436 6 10.616V19.385C6 19.5643 6.05767 19.7117 6.173 19.827C6.28833 19.9423 6.436 20 6.616 20ZM12 16.5C12.422 16.5 12.7773 16.3553 13.066 16.066C13.3553 15.7773 13.5 15.422 13.5 15C13.5 14.578 13.3553 14.2227 13.066 13.934C12.7767 13.6453 12.4213 13.5007 12 13.5C11.5787 13.4993 11.2233 13.644 10.934 13.934C10.6447 14.2227 10.5 14.578 10.5 15C10.5 15.422 10.6447 15.7773 10.934 16.066C11.2227 16.3553 11.578 16.5 12 16.5ZM9 9H15V7C15 6.16667 14.7083 5.45833 14.125 4.875C13.5417 4.29167 12.8333 4 12 4C11.1667 4 10.4583 4.29167 9.875 4.875C9.29167 5.45833 9 6.16667 9 7V9Z" fill="#888888"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  fitnessTest.goal.goalName != "" ? (
                    <div className="w-full m-t-16">
                      <p className="flex-item fs-16 font-weight-700 m-b-12">Goal - <span className="color-dark-blue">{fitnessTest.goal.goalName}</span></p>
                      <div className="d-flex space-between">
                        <div onClick={toggleInputFields('goal-display-name')} className={`${(currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "1px solid var(--darkBlue)" : "", width: "84%" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "10px" : "14px", color: (currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Goal Display Name</p>
                          </div>
                          <div className={`${(currentElementId == 'goal-display-name' || fitnessTest.goal.goalDisplayName) ? "active-input-field w-full" : "inactive-input-field"} space-between d-flex`} style={{width:"95%", marginLeft:"-2px", marginTop:"16px"}}>
                            <input onChange={handleChange("")} value={fitnessTest.goal.goalDisplayName} style={{color: "#2b2b2b", width:"90%"}} type="text" placeholder='Enter Goal Name' disabled={goalType == "prev-goal" ? true : false} />
                            {
                              goalType == "prev-goal" && (
                                <svg style={{marginTop:"-8px"}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.616 21C6.168 21 5.78667 20.8427 5.472 20.528C5.15733 20.2133 5 19.8323 5 19.385V10.615C5 10.1683 5.15733 9.78733 5.472 9.472C5.78667 9.15733 6.168 9 6.616 9H8V7C8 5.886 8.38833 4.941 9.165 4.165C9.941 3.38833 10.886 3 12 3C13.114 3 14.0593 3.38833 14.836 4.165C15.6127 4.94167 16.0007 5.88667 16 7V9H17.385C17.8317 9 18.2127 9.15733 18.528 9.472C18.8427 9.78667 19 10.168 19 10.616V19.385C19 19.8317 18.8427 20.2127 18.528 20.528C18.2133 20.8427 17.8323 21 17.385 21H6.616ZM6.616 20H17.385C17.5643 20 17.7117 19.9423 17.827 19.827C17.9423 19.7117 18 19.5643 18 19.385V10.615C18 10.4357 17.9423 10.2883 17.827 10.173C17.7117 10.0577 17.5643 10 17.385 10H6.615C6.43567 10 6.28833 10.0577 6.173 10.173C6.05767 10.2883 6 10.436 6 10.616V19.385C6 19.5643 6.05767 19.7117 6.173 19.827C6.28833 19.9423 6.436 20 6.616 20ZM12 16.5C12.422 16.5 12.7773 16.3553 13.066 16.066C13.3553 15.7773 13.5 15.422 13.5 15C13.5 14.578 13.3553 14.2227 13.066 13.934C12.7767 13.6453 12.4213 13.5007 12 13.5C11.5787 13.4993 11.2233 13.644 10.934 13.934C10.6447 14.2227 10.5 14.578 10.5 15C10.5 15.422 10.6447 15.7773 10.934 16.066C11.2227 16.3553 11.578 16.5 12 16.5ZM9 9H15V7C15 6.16667 14.7083 5.45833 14.125 4.875C13.5417 4.29167 12.8333 4 12 4C11.1667 4 10.4583 4.29167 9.875 4.875C9.29167 5.45833 9 6.16667 9 7V9Z" fill="#888888"/>
                                </svg>
                              )
                            }
                          </div>
                        </div>
                        <div onClick={handleRemoveGoal} className="ft-goal-action-btn d-flex flex-item cursor-pointer button-red">
                          <svg className="flex-item margin-auto fill-svg" width="25" height="25" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.98198 18.3338C6.57132 18.3338 6.22176 18.1895 5.93332 17.9011C5.64487 17.6127 5.50065 17.2634 5.50065 16.8533V5.50043H4.58398V4.58376H8.25065V3.87793H13.7507V4.58376H17.4173V5.50043H16.5006V16.8533C16.5006 17.275 16.3595 17.6273 16.0771 17.9103C15.7948 18.1932 15.4422 18.3344 15.0193 18.3338H6.98198ZM15.584 5.50043H6.41732V16.8533C6.41732 17.0177 6.47018 17.1528 6.5759 17.2585C6.68162 17.3642 6.81698 17.4171 6.98198 17.4171H15.0202C15.1608 17.4171 15.29 17.3584 15.408 17.2411C15.5259 17.1238 15.5846 16.9942 15.584 16.8524V5.50043ZM8.99132 15.5838H9.90798V7.33376H8.99132V15.5838ZM12.0933 15.5838H13.01V7.33376H12.0933V15.5838Z" fill="#E33A34"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-full ft-select-goal m-t-12">
                      <div className="w-full h-full p-r-6" style={{overflowY:"auto"}}>
                        {
                          memberInfo.memberGoal && memberInfo.memberGoal.filter(g => g.goalStatus === "inactive").length > 0 && (
                            <div className="w-full">
                              <p className="fs-16 color-dark-blue font-weight-700 m-b-8">Select Goal</p>
                              {
                                memberInfo.memberGoal.filter(g => g.goalStatus == "inactive").map(data => {
                                  return(
                                    <div onClick={()=> handleSelectFitnessGoal(data, "prev-goal")} className="d-flex m-b-8 cursor-pointer" style={{background:"#e3eef2ff", padding: "8px 12px", borderRadius:"8px"}}>
                                      <p className="flex-item color-black font-weight-600">{data.goalDisplayName}</p>
                                    </div>
                                  )
                                })
                              }
                              {
                                memberInfo.memberGoal.filter(g => g.goalStatus == "inactive").length > 0 && allGoals.filter(data=>!(memberInfo.memberGoal.findIndex(data2=>data2.goalName == data.name)!=-1)).length > 0 && (
                                  <svg className="flex-item m-t-8 m-b-16" width="100%" height="1.3" viewBox="0 0 350 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.5" x2="350" y2="0.5" stroke="#b9b9b9" stroke-dasharray="4 4"/>
                                  </svg>
                                )
                              }
                            </div>
                          )
                        }
                        {
                          memberInfo && memberInfo.memberGoal && memberInfo.memberGoal.length > 0 ? (
                            <>
                              {allGoals.filter(data=>!(memberInfo.memberGoal.findIndex(data2=>data2.goalName == data.name)!=-1)).length > 0 && (
                                <p className="fs-16 color-red font-weight-700 m-b-12">Assign New Goal </p>
                              )}
                              {
                                allGoals.filter(data=>!(memberInfo.memberGoal.findIndex(data2=>data2.goalName == data.name)!=-1)).map((data,index) => {
                                  return(
                                    <div onClick={()=>handleSelectFitnessGoal(data, "new-goal")} className="d-flex m-b-8 cursor-pointer" style={{background:"#f4e3e3ff", padding: "8px 12px", borderRadius:"8px"}}>
                                      <p className="flex-item color-black font-weight-600">{data.name}</p>
                                    </div>
                                  )
                                })
                              }
                            </>
                        ) : (
                            <>
                              <p className="fs-16 color-red font-weight-700 m-b-12">Assign New Goal </p>
                              {
                                allGoals.map((data,index) => {
                                  return(
                                    <div onClick={()=>handleSelectFitnessGoal(data, "new-goal")} className="d-flex m-b-8 cursor-pointer" style={{background:"#f4e3e3ff", padding: "8px 12px", borderRadius:"8px"}}>
                                      <p className="flex-item color-black font-weight-600">{data.name}</p>
                                    </div>
                                  )
                                })
                              }
                            </>
                        )
                        }
                      </div>
                      
                    </div>
                  )
                )
              }
              

              <svg className="flex-item m-t-20 m-b-20" width="100%" height="2" viewBox="0 0 365 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.5" x2="365.001" y2="0.5" stroke="#c9c9c9" stroke-dasharray="4 4"/>
              </svg>

              <div className="d-flex">
                <p className="flex-item fs-16 font-weight-700">{fitnessTest.weight.value != "" && fitnessTest.height.value != "" ? "BMI" : "Calculate BMI"}</p>
                {
                  fitnessTest.weight.value != "" && fitnessTest.height.value != "" && (
                    <p className="flex-item fs-16 m-l-12"><span className="font-weight-700" style={{color:"#0088da"}}>{fitnessTest.bmi.value} - {fitnessTest.bmi.bodyType}</span></p>
                  )
                }
              </div>
              <div className="d-flex space-between m-t-8">
                <div onClick={toggleInputFields('user-weight')} className={`${(currentElementId == 'user-weight' || fitnessTest.weight.value) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'user-weight' || fitnessTest.weight.value) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'user-weight' || fitnessTest.weight.value) ? "10px" : "14px", color: (currentElementId == 'user-weight' || fitnessTest.weight.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Weight (Kg)</p>
                  </div>
                  <input onChange={handleChange("")} value={fitnessTest.weight.value} className={`${(currentElementId == 'user-weight' || fitnessTest.weight.value) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#2b2b2b"}} type="number" placeholder='Enter Weight in Kg' />
                </div>
                <div onClick={toggleInputFields('user-height')} className={`${(currentElementId == 'user-height' || fitnessTest.height.value) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'user-height' || fitnessTest.height.value) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'user-height' || fitnessTest.height.value) ? "10px" : "14px", color: (currentElementId == 'user-height' || fitnessTest.height.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Height (Ft)</p>
                  </div>
                  <input onChange={handleChange("")} value={fitnessTest.height.value} className={`${(currentElementId == 'user-height' || fitnessTest.height.value) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#2b2b2b"}} type="number" placeholder='Enter Height in Feet' />
                </div>
              </div>
              <p className="color-black fs-16 font-weight-700 m-t-12 m-b-12">Member Image</p>
              <div className="d-flex-wrap">
                {
                  fitnessTest.images.map((data,index) => {
                    return(
                      <div className="upload-member-image-container m-r-12 m-b-12 flex-item">
                        <img className="w-full h-full" style={{borderRadius:"12px"}}  src={URL.createObjectURL(data)} />
                        <div onClick={()=>handleDeleteImage(index)} className="d-flex delete-selected-ft-image cursor-pointer">
                          <svg className="flex-item margin-auto svg-fill" width="8" height="8" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.9283 0.809144C1.77899 0.664936 1.57901 0.58514 1.37144 0.586944C1.16387 0.588748 0.965309 0.672007 0.818528 0.818788C0.671747 0.96557 0.588488 1.16413 0.586684 1.3717C0.58488 1.57927 0.664676 1.77925 0.808884 1.92856L5.38076 6.50044L0.808093 11.0723C0.73248 11.1453 0.672169 11.2327 0.630679 11.3293C0.589188 11.4259 0.56735 11.5298 0.566436 11.6349C0.565523 11.74 0.585553 11.8442 0.625359 11.9415C0.665164 12.0388 0.723948 12.1272 0.79828 12.2015C0.872612 12.2759 0.961003 12.3347 1.0583 12.3745C1.15559 12.4143 1.25983 12.4343 1.36495 12.4334C1.47007 12.4325 1.57395 12.4106 1.67054 12.3691C1.76712 12.3277 1.85448 12.2673 1.92751 12.1917L6.50018 7.61985L11.0721 12.1917C11.2214 12.3359 11.4213 12.4157 11.6289 12.4139C11.8365 12.4121 12.035 12.3289 12.1818 12.1821C12.3286 12.0353 12.4119 11.8367 12.4137 11.6292C12.4155 11.4216 12.3357 11.2216 12.1915 11.0723L7.61959 6.50044L12.1915 1.92856C12.3357 1.77925 12.4155 1.57927 12.4137 1.3717C12.4119 1.16413 12.3286 0.96557 12.1818 0.818788C12.035 0.672007 11.8365 0.588748 11.6289 0.586944C11.4213 0.58514 11.2214 0.664936 11.0721 0.809144L6.50018 5.38102L1.9283 0.808353V0.809144Z" fill="#ffffff"/>
                          </svg>
                        </div>
                      </div>
                    )
                  })
                }
                <div className="upload-member-image-container m-r-12 m-b-12 flex-item">
                  <svg style={{position:"absolute", zIndex:0}} width="116" height="114" viewBox="0 0 116 114" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.25" y="0.986328" width="115.5" height="112.5" rx="13.75" fill="#FAFAFA" stroke="black" stroke-width="0.5" stroke-dasharray="6 6"/>
                  </svg>
                  <div className="d-flex inner-container cursor-pointer" style={{zIndex:2, position:"absolute"}}>
                    <div className="flex-item margin-auto" style={{justifyContent:"center", textAlign:"center"}}>
                      <svg width="36" height="36" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.89474 0.736328H26.1053C27.4034 0.736328 28.6484 1.23539 29.5664 2.12372C30.4843 3.01205 31 4.21688 31 5.47317V25.9995C31 27.2558 30.4843 28.4606 29.5664 29.3489C28.6484 30.2373 27.4034 30.7363 26.1053 30.7363H4.89474C3.59657 30.7363 2.35158 30.2373 1.43364 29.3489C0.515694 28.4606 0 27.2558 0 25.9995V5.47317C0 4.21688 0.515694 3.01205 1.43364 2.12372C2.35158 1.23539 3.59657 0.736328 4.89474 0.736328ZM4.89474 2.31528C4.02929 2.31528 3.1993 2.64798 2.58734 3.2402C1.97537 3.83242 1.63158 4.63564 1.63158 5.47317V23.7732L8.63105 16.9837L12.71 20.9311L20.8679 13.0363L29.3684 21.2626V5.47317C29.3684 4.63564 29.0246 3.83242 28.4127 3.2402C27.8007 2.64798 26.9707 2.31528 26.1053 2.31528H4.89474ZM12.71 23.1732L8.63105 19.2258L1.63158 25.9995C1.63158 26.837 1.97537 27.6402 2.58734 28.2325C3.1993 28.8247 4.02929 29.1574 4.89474 29.1574H26.1053C26.9707 29.1574 27.8007 28.8247 28.4127 28.2325C29.0246 27.6402 29.3684 26.837 29.3684 25.9995V23.489L20.8679 15.2784L12.71 23.1732ZM8.97368 5.47317C10.0555 5.47317 11.093 5.88905 11.8579 6.62933C12.6229 7.3696 13.0526 8.37363 13.0526 9.42054C13.0526 10.4674 12.6229 11.4715 11.8579 12.2118C11.093 12.952 10.0555 13.3679 8.97368 13.3679C7.89188 13.3679 6.85438 12.952 6.08943 12.2118C5.32448 11.4715 4.89474 10.4674 4.89474 9.42054C4.89474 8.37363 5.32448 7.3696 6.08943 6.62933C6.85438 5.88905 7.89188 5.47317 8.97368 5.47317ZM8.97368 7.05212C8.3246 7.05212 7.7021 7.30165 7.24313 7.74581C6.78416 8.18998 6.52632 8.79239 6.52632 9.42054C6.52632 10.0487 6.78416 10.6511 7.24313 11.0953C7.7021 11.5394 8.3246 11.789 8.97368 11.789C9.62277 11.789 10.2453 11.5394 10.7042 11.0953C11.1632 10.6511 11.4211 10.0487 11.4211 9.42054C11.4211 8.79239 11.1632 8.18998 10.7042 7.74581C10.2453 7.30165 9.62277 7.05212 8.97368 7.05212Z" fill="#828282"/>
                      </svg>
                      <p className="flex-item fs-12 m-t-4">Upload Image</p>
                    </div>
                    <input onChange={handleAddImage} type="file" multiple className="w-full h-full" style={{zIndex:3}} />
                  </div>
                </div>
              </div>

              <svg className="flex-item m-b-20 m-t-12" width="100%" height="2" viewBox="0 0 365 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.5" x2="365.001" y2="0.5" stroke="#c9c9c9" stroke-dasharray="4 4"/>
              </svg>

              <div className="d-flex">
                <div onClick={()=>handleFitnessType("fitness-measurement")} className="d-flex ft-data-container cursor-pointer" style={{background: fitnessTestDataType == "fitness-measurement" ? "#ffffff" : "#e0e0e0"}}>
                  <svg className="flex-item m-r-8" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19V24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24V19C15.866 19 19 15.866 19 12Z" fill={fitnessTestDataType == "fitness-measurement" ? "var(--darkBlue)" : "#6d6d6d"}/>
                  </svg>
                  <p className="flex-item">Fitness Measurement</p>
                </div>
                <svg className="flex-item" width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line y1="1" x2="19.0263" y2="1" stroke="#A1A1A1" stroke-dasharray="2 2"/>
                </svg>
                <div onClick={()=>handleFitnessType("fitness-test")} className="d-flex ft-data-container cursor-pointer" style={{background: fitnessTestDataType == "fitness-test" ? "#ffffff" : "#e0e0e0"}}>
                  <svg className="flex-item m-r-8" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19V24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24V19C15.866 19 19 15.866 19 12Z" fill={fitnessTestDataType == "fitness-test" ? "var(--darkBlue)" : "#6d6d6d"}/>
                  </svg>
                  <p className="flex-item">Fitness Test</p>
                </div>
              </div>

              {
                fitnessTestDataType == "fitness-measurement" && (
                  <div className="m-t-20 p-l-12 p-r-12 p-b-12 p-t-12" style={{background:"#ffffff", borderRadius:"12px"}}>
                    <div className="d-flex space-between m-b-12">
                      <div className="flex-item d-flex" style={{width:"50%"}}>
                        <p className="flex-item margin-auto font-weight-700">Current</p>
                      </div>
                      <div className="flex-item d-flex" style={{width:"50%"}}>
                        <p className="flex-item margin-auto font-weight-700">Goal</p>
                      </div>
                    </div>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('chest-current')} className={`${(currentElementId == 'chest-current' || fitnessTest.fitnessMeasurement.chest) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'chest-current' || fitnessTest.fitnessMeasurement.chest) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'chest-current' || fitnessTest.fitnessMeasurement.chest) ? "10px" : "14px", color: (currentElementId == 'chest-current' || fitnessTest.fitnessMeasurement.chest) ? "var(--darkBlue)" : "", transition: "180ms" }}>Chest (cm)</p>
                        </div>
                        <input id="chest-current" onChange={handleChange("")} value={fitnessTest.fitnessMeasurement.chest} className={`${(currentElementId == 'chest-current' || fitnessTest.fitnessMeasurement.chest) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                      </div>
                      <div onClick={toggleInputFields('chest-goal')} className={`${(currentElementId == 'chest-goal' || fitnessMeasurementGoal.chest) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'chest-goal' || fitnessMeasurementGoal.chest) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'chest-goal' || fitnessMeasurementGoal.chest) ? "10px" : "14px", color: (currentElementId == 'chest-goal' || fitnessMeasurementGoal.chest) ? "var(--darkBlue)" : "", transition: "180ms" }}>Chest (cm)</p>
                        </div>
                        <input id="chest-goal" onChange={handleChange("")} value={fitnessMeasurementGoal.chest} className={`${(currentElementId == 'chest-goal' || fitnessMeasurementGoal.chest) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#5D883C"}} type="number" placeholder='00' />
                      </div>
                    </div>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('thigh-circumference-current')} className={`${(currentElementId == 'thigh-circumference-current' || fitnessTest.fitnessMeasurement.thighCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'thigh-circumference-current' || fitnessTest.fitnessMeasurement.thighCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'thigh-circumference-current' || fitnessTest.fitnessMeasurement.thighCircumference) ? "10px" : "14px", color: (currentElementId == 'thigh-circumference-current' || fitnessTest.fitnessMeasurement.thighCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Thigh Circumference</p>
                        </div>
                        <input id="thigh-circumference-current" onChange={handleChange("")} value={fitnessTest.fitnessMeasurement.thighCircumference} className={`${(currentElementId == 'thigh-circumference-current' || fitnessTest.fitnessMeasurement.thighCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                      </div>
                      <div onClick={toggleInputFields('thigh-circumference-goal')} className={`${(currentElementId == 'thigh-circumference-goal' || fitnessMeasurementGoal.thighCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'thigh-circumference-goal' || fitnessMeasurementGoal.thighCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'thigh-circumference-goal' || fitnessMeasurementGoal.thighCircumference) ? "10px" : "14px", color: (currentElementId == 'thigh-circumference-goal' || fitnessMeasurementGoal.thighCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Thigh Circumference</p>
                        </div>
                        <input id="thigh-circumference-goal" onChange={handleChange("")} value={fitnessMeasurementGoal.thighCircumference} className={`${(currentElementId == 'thigh-circumference-goal' || fitnessMeasurementGoal.thighCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#5d883c"}} type="number" placeholder='00' />
                      </div>
                    </div>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('mid-arm-circumference-current')} className={`${(currentElementId == 'mid-arm-circumference-current' || fitnessTest.fitnessMeasurement.midArmCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'mid-arm-circumference-current' || fitnessTest.fitnessMeasurement.midArmCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'mid-arm-circumference-current' || fitnessTest.fitnessMeasurement.midArmCircumference) ? "10px" : "14px", color: (currentElementId == 'mid-arm-circumference-current' || fitnessTest.fitnessMeasurement.midArmCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mid Arm Circumference</p>
                        </div>
                        <input id="mid-arm-circumference-current" onChange={handleChange("")} value={fitnessTest.fitnessMeasurement.midArmCircumference} className={`${(currentElementId == 'mid-arm-circumference-current' || fitnessTest.fitnessMeasurement.midArmCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                      </div>
                      <div onClick={toggleInputFields('mid-arm-circumference-goal')} className={`${(currentElementId == 'mid-arm-circumference-goal' || fitnessMeasurementGoal.midArmCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'mid-arm-circumference-goal' || fitnessMeasurementGoal.midArmCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'mid-arm-circumference-goal' || fitnessMeasurementGoal.midArmCircumference) ? "10px" : "14px", color: (currentElementId == 'mid-arm-circumference-goal' || fitnessMeasurementGoal.midArmCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Mid Arm Circumference</p>
                        </div>
                        <input id="mid-arm-circumference-goal" onChange={handleChange("")} value={fitnessMeasurementGoal.midArmCircumference} className={`${(currentElementId == 'mid-arm-circumference-goal' || fitnessMeasurementGoal.midArmCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#5d883c"}} type="number" placeholder='00' />
                      </div>
                    </div>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('fore-arm-circumference-current')} className={`${(currentElementId == 'fore-arm-circumference-current' || fitnessTest.fitnessMeasurement.foreArmCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'fore-arm-circumference-current' || fitnessTest.fitnessMeasurement.foreArmCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'fore-arm-circumference-current' || fitnessTest.fitnessMeasurement.foreArmCircumference) ? "10px" : "14px", color: (currentElementId == 'fore-arm-circumference-current' || fitnessTest.fitnessMeasurement.foreArmCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Fore Arm Circumference</p>
                        </div>
                        <input id="fore-arm-circumference-current" onChange={handleChange("")} value={fitnessTest.fitnessMeasurement.foreArmCircumference} className={`${(currentElementId == 'fore-arm-circumference-current' || fitnessTest.fitnessMeasurement.foreArmCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                      </div>
                      <div onClick={toggleInputFields('fore-arm-circumference-goal')} className={`${(currentElementId == 'fore-arm-circumference-goal' || fitnessMeasurementGoal.foreArmCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'fore-arm-circumference-goal' || fitnessMeasurementGoal.foreArmCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'fore-arm-circumference-goal' || fitnessMeasurementGoal.foreArmCircumference) ? "10px" : "14px", color: (currentElementId == 'fore-arm-circumference-goal' || fitnessMeasurementGoal.foreArmCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Fore Arm Circumference</p>
                        </div>
                        <input id="fore-arm-circumference-goal" onChange={handleChange("")} value={fitnessMeasurementGoal.foreArmCircumference} className={`${(currentElementId == 'fore-arm-circumference-goal' || fitnessMeasurementGoal.foreArmCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#5d883c"}} type="number" placeholder='00' />
                      </div>
                    </div>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('upper-arm-circumference-current')} className={`${(currentElementId == 'upper-arm-circumference-current' || fitnessTest.fitnessMeasurement.upperArmCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'upper-arm-circumference-current' || fitnessTest.fitnessMeasurement.upperArmCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'upper-arm-circumference-current' || fitnessTest.fitnessMeasurement.upperArmCircumference) ? "10px" : "14px", color: (currentElementId == 'upper-arm-circumference-current' || fitnessTest.fitnessMeasurement.upperArmCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Upper Arm Circumference</p>
                        </div>
                        <input id="upper-arm-circumference-current" onChange={handleChange("")} value={fitnessTest.fitnessMeasurement.upperArmCircumference} className={`${(currentElementId == 'upper-arm-circumference-current' || fitnessTest.fitnessMeasurement.upperArmCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                      </div>
                      <div onClick={toggleInputFields('upper-arm-circumference-goal')} className={`${(currentElementId == 'upper-arm-circumference-goal' || fitnessMeasurementGoal.upperArmCircumference) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'upper-arm-circumference-goal' || fitnessMeasurementGoal.upperArmCircumference) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'upper-arm-circumference-goal' || fitnessMeasurementGoal.upperArmCircumference) ? "10px" : "14px", color: (currentElementId == 'upper-arm-circumference-goal' || fitnessMeasurementGoal.upperArmCircumference) ? "var(--darkBlue)" : "", transition: "180ms" }}>Upper Arm Circumference</p>
                        </div>
                        <input id="upper-arm-circumference-goal" onChange={handleChange("")} value={fitnessMeasurementGoal.upperArmCircumference} className={`${(currentElementId == 'upper-arm-circumference-goal' || fitnessMeasurementGoal.upperArmCircumference) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#5d883c"}} type="number" placeholder='00' />
                      </div>
                    </div>
                    <div className="d-flex space-between">
                      <div onClick={toggleInputFields('waist-current')} className={`${(currentElementId == 'waist-current' || fitnessTest.fitnessMeasurement.waist) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'waist-current' || fitnessTest.fitnessMeasurement.waist) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'waist-current' || fitnessTest.fitnessMeasurement.waist) ? "10px" : "14px", color: (currentElementId == 'waist-current' || fitnessTest.fitnessMeasurement.waist) ? "var(--darkBlue)" : "", transition: "180ms" }}>Waist</p>
                        </div>
                        <input id="waist-current" onChange={handleChange("")} value={fitnessTest.fitnessMeasurement.waist} className={`${(currentElementId == 'waist-current' || fitnessTest.fitnessMeasurement.waist) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                      </div>
                      <div onClick={toggleInputFields('waist-goal')} className={`${(currentElementId == 'waist-goal' || fitnessMeasurementGoal.waist) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'waist-goal' || fitnessMeasurementGoal.waist) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'waist-goal' || fitnessMeasurementGoal.waist) ? "10px" : "14px", color: (currentElementId == 'waist-goal' || fitnessMeasurementGoal.waist) ? "var(--darkBlue)" : "", transition: "180ms" }}>Waist</p>
                        </div>
                        <input id="waist-goal" onChange={handleChange("")} value={fitnessMeasurementGoal.waist} className={`${(currentElementId == 'waist-goal' || fitnessMeasurementGoal.waist) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#5d883c"}} type="number" placeholder='00' />
                      </div>
                    </div>
                  </div>
                )
              }

              <div id="target"/>

              {
                fitnessTestDataType == "fitness-test" && [
                  <div className="m-t-20"/>,
                  
                  // (achievements.length > 0 && selectedFitnessPlanner.length == 0) && (
                  // )
                  
                  isFitnessPlannerSelected ? (
                    <div className="flex-item w-full">
                      <div onClick={()=> parentReport == "" && handleUnselectFitnessPlanner()} className="flex-item d-flex m-b-20 cursor-pointer">
                        {
                          parentReport == "" && (
                            <svg className="flex-item m-r-8" width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.0312 9C17.5835 9 18.0312 8.55228 18.0312 8C18.0312 7.44772 17.5835 7 17.0312 7V8V9ZM0.292923 7.29289C-0.0976009 7.68342 -0.0976009 8.31658 0.292923 8.70711L6.65689 15.0711C7.04741 15.4616 7.68057 15.4616 8.0711 15.0711C8.46162 14.6805 8.46162 14.0474 8.0711 13.6569L2.41424 8L8.0711 2.34315C8.46162 1.95262 8.46162 1.31946 8.0711 0.928932C7.68057 0.538408 7.04741 0.538408 6.65689 0.928932L0.292923 7.29289ZM17.0312 8V7L1.00003 7V8V9L17.0312 9V8Z" fill="#E33A34"/>
                            </svg>
                          )
                        }
                        <p className="flex-item fs-16 font-weight-700 color-dark-blue" style={{textTransform:"capitalize"}}>{fitnessTest.selectedFitnessPlanner && fitnessTest.selectedFitnessPlanner.plannerName ? fitnessTest.selectedFitnessPlanner.plannerName : "Name"}</p>
                      </div>
                      {
                        fitnessTest.fitnessTests.map((exercise, index) => {
                          return(
                            <div className="w-full m-b-16">
                              <div className="d-flex space-between">
                                <div className="flex-item m-b-8">
                                  <p className="fs-14 font-weight-700" style={{textTransform:"capitalize", lineHeight:"14px"}}>{exercise.exerciseName}</p>
                                  <p className="fs-12">Unit - {exercise.exerciseUnit}</p>
                                </div>
                                <svg className="flex-item" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9.33334 0C7.48738 0 5.68287 0.54739 4.14802 1.57295C2.61316 2.59851 1.41688 4.05618 0.710462 5.76162C0.00404396 7.46707 -0.180787 9.34369 0.179342 11.1542C0.53947 12.9647 1.42838 14.6277 2.73367 15.933C4.03896 17.2383 5.70201 18.1272 7.5125 18.4873C9.32298 18.8475 11.1996 18.6626 12.9051 17.9562C14.6105 17.2498 16.0682 16.0535 17.0937 14.5187C18.1193 12.9838 18.6667 11.1793 18.6667 9.33333C18.6667 6.85798 17.6833 4.48401 15.933 2.73367C14.1827 0.983331 11.8087 0 9.33334 0ZM1.16667 9.33333C1.16723 7.37093 1.87793 5.47503 3.1675 3.99583L14.6708 15.4992C13.4878 16.5208 12.0364 17.1814 10.489 17.4026C8.94163 17.6238 7.36327 17.3963 5.94137 16.7471C4.51946 16.0978 3.31374 15.0542 2.46738 13.74C1.62102 12.4259 1.16958 10.8964 1.16667 9.33333ZM15.4992 14.6708L3.99584 3.1675C5.56113 1.85963 7.5592 1.18486 9.59694 1.27597C11.6347 1.36707 13.5646 2.21744 15.0069 3.65978C16.4492 5.10212 17.2996 7.032 17.3907 9.06974C17.4818 11.1075 16.807 13.1055 15.4992 14.6708Z" fill="#969696"/>
                                </svg>
                              </div>
                              <div className="d-flex space-between">
                                <div onClick={toggleInputFields('fp-achievement-'+index)} className={`${(currentElementId == 'fp-achievement-'+index || exercise.value) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'fp-achievement-'+index || exercise.value) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'fp-achievement-'+index || exercise.value) ? "10px" : "14px", color: (currentElementId == 'fp-achievement-'+index || exercise.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Achievement</p>
                                  </div>
                                  <input id={'fp-achievement-'+index} onChange={handleChange(index)} value={exercise.value} className={`${(currentElementId == 'fp-achievement-'+index || exercise.value) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                                </div>

                                <div onClick={toggleInputFields('fp-goal-'+index)} className={`${(currentElementId == 'fp-goal-'+index || exercise.goal) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-8`} style={{ border: (currentElementId == 'fp-goal-'+index || exercise.goal) ? "1px solid var(--darkBlue)" : "", width: "49%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'fp-goal-'+index || exercise.goal) ? "10px" : "14px", color: (currentElementId == 'fp-goal-'+index || exercise.goal) ? "var(--darkBlue)" : "", transition: "180ms" }}>Goal</p>
                                  </div>
                                  <input id={'fp-goal-'+index} onChange={handleChange(index)} value={exercise.goal} className={`${(currentElementId == 'fp-goal-'+index || exercise.goal) ? "active-input-field" : "inactive-input-field"}`} style={{color: "#E33A34"}} type="number" placeholder='00' />
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  ) : (
                    <div className="flex-item w-full">
                      <SearchFilter count="0" searchingData={handleUserSearchKey} searchType={"Fitness Planner"} isSearchEnabled={true} isFilterEnabled={false} />
                      <div className="m-b-20" />
                      {
                        allFitnessTestPlanners.map((data,index) => {
                          return(
                            <div className="flex-item p-b-10 m-b-16" style={{borderBottom:"1px solid #e0e0e0"}}>
                              <div className="d-flex cursor-pointer m-l-10 space-between">
                                <div onClick={()=>handleSelectFitnessTest(data, index)} className="d-flex" style={{width:"80%"}}>
                                  <input className="m-r-8" style={{alignSelf:"flex-start", width:"16px", height:"16px"}} type="radio" checked={selectedPlannerIndex == index ? true : false} />
                                  <div style={{alignSelf:"flex-start"}}>
                                    <p className="fs-15 font-weight-700 m-t-1" style={{lineHeight:"15px"}}>{data.name}</p>
                                    <p className="fs-12 color-grey-02">{data.exercises.length} Exercise<span>{data.exercises.length > 1 && "s"}</span></p>
                                  </div>
                                </div>
                                {
                                  selectedPlannerIndex == index && (
                                    <div onClick={()=>handleSelectFitnessPlanner()} className="d-flex ft-planner-action-btn" style={{marginTop:"-2px", alignSelf:"flex-start"}}>
                                      <svg className="flex-item margin-auto" width="14" height="14" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 6.99023C0.447715 6.99023 0 7.43795 0 7.99023C0 8.54252 0.447715 8.99023 1 8.99023V7.99023V6.99023ZM17.7383 8.69734C18.1289 8.30682 18.1289 7.67365 17.7383 7.28313L11.3744 0.919167C10.9838 0.528642 10.3507 0.528642 9.96015 0.919167C9.56963 1.30969 9.56963 1.94286 9.96015 2.33338L15.617 7.99023L9.96015 13.6471C9.56963 14.0376 9.56963 14.6708 9.96015 15.0613C10.3507 15.4518 10.9838 15.4518 11.3744 15.0613L17.7383 8.69734ZM1 7.99023V8.99023H17.0312V7.99023V6.99023H1V7.99023Z" fill="white"/>
                                      </svg>
                                    </div>
                                  )
                                }
                              </div>
                              {
                                data.exercises.length > 0 && selectedPlannerIndex == index && (
                                  <div className="m-t-8 p-l-12 p-r-12 p-b-8 m-b-8 p-t-12" style={{borderRadius:"12px", background:"#ffffff"}}>
                                    {
                                      data.exercises.map((exercises,index) => {
                                        return(
                                          <div className="d-flex" style={{borderBottom: data.exercises.length != index + 1 && "1px solid #eaeaea", marginBottom: data.exercises.length != index + 1 && "12px", paddingBottom: data.exercises.length != index + 1 && "8px" }}>
                                            <div className="d-flex fitness-test-content-point m-r-10" style={{alignSelf:"flex-start"}}>
                                              <svg className="flex-item margin-auto" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.4001 6.3747L15.7121 5.6867L16.1921 5.1807C16.3208 5.0527 16.3851 4.90837 16.3851 4.7477C16.3851 4.5877 16.3208 4.44337 16.1921 4.3147L13.6841 1.8077C13.5561 1.6797 13.4121 1.6157 13.2521 1.6157C13.0921 1.6157 12.9478 1.6797 12.8191 1.8077L12.3131 2.2877L11.6001 1.5747L12.1581 0.991703C12.4514 0.69837 12.8111 0.556037 13.2371 0.564703C13.6631 0.57337 14.0228 0.724037 14.3161 1.0167L16.9831 3.6847C17.2764 3.97804 17.4231 4.33337 17.4231 4.7507C17.4231 5.16804 17.2764 5.52337 16.9831 5.8167L16.4001 6.3747ZM5.84209 16.9577C5.54876 17.251 5.19343 17.3977 4.77609 17.3977C4.35876 17.3977 4.00343 17.251 3.71009 16.9577L1.12009 14.3677C0.813427 14.061 0.660094 13.6797 0.660094 13.2237C0.660094 12.7677 0.813427 12.3867 1.12009 12.0807L1.60009 11.5997L2.31409 12.3137L1.82709 12.7937C1.69909 12.9224 1.63509 13.0667 1.63509 13.2267C1.63509 13.3867 1.69909 13.531 1.82709 13.6597L4.34109 16.1727C4.46909 16.3014 4.61309 16.3657 4.77309 16.3657C4.93309 16.3657 5.07743 16.3014 5.20609 16.1727L5.68609 15.6867L6.40009 16.3997L5.84209 16.9577ZM15.5751 10.1537L16.7121 9.0167C16.8401 8.8887 16.9041 8.74137 16.9041 8.5747C16.9041 8.40804 16.8401 8.2607 16.7121 8.1327L9.86709 1.2887C9.73909 1.16004 9.59176 1.0957 9.42509 1.0957C9.25843 1.0957 9.11109 1.1597 8.98309 1.2877L7.84609 2.4247C7.71809 2.5527 7.65409 2.69704 7.65409 2.8577C7.65409 3.0177 7.71809 3.16204 7.84609 3.2907L14.7101 10.1537C14.8381 10.2817 14.9821 10.3457 15.1421 10.3457C15.3021 10.3457 15.4464 10.2817 15.5751 10.1537ZM9.01709 16.7117L10.1541 15.5687C10.2821 15.4407 10.3461 15.2967 10.3461 15.1367C10.3461 14.9767 10.2821 14.8324 10.1541 14.7037L3.29609 7.8457C3.16809 7.7177 3.02376 7.6537 2.86309 7.6537C2.70309 7.6537 2.55909 7.7177 2.43109 7.8457L1.28809 8.9827C1.16009 9.1107 1.09609 9.25804 1.09609 9.4247C1.09609 9.59137 1.16009 9.7387 1.28809 9.8667L8.13309 16.7107C8.26109 16.8394 8.40843 16.9037 8.57509 16.9037C8.74176 16.9037 8.88909 16.8397 9.01709 16.7117ZM8.30909 11.4387L11.4441 8.3087L9.69009 6.5557L6.56109 9.6907L8.30909 11.4387ZM9.71109 17.4187C9.40509 17.7254 9.02643 17.8787 8.57509 17.8787C8.12376 17.8787 7.74476 17.7254 7.43809 17.4187L0.581094 10.5617C0.274427 10.255 0.121094 9.87604 0.121094 9.4247C0.121094 8.97337 0.274427 8.5947 0.581094 8.2887L1.71709 7.1327C2.02376 6.82604 2.40509 6.6727 2.86109 6.6727C3.31709 6.6727 3.69809 6.82604 4.00409 7.1327L5.84809 8.9767L8.98309 5.8417L7.13909 4.0037C6.83243 3.69704 6.67909 3.31504 6.67909 2.8577C6.67909 2.40037 6.83243 2.01837 7.13909 1.7117L8.29409 0.555703C8.60076 0.249036 8.98176 0.0957031 9.43709 0.0957031C9.89243 0.0957031 10.2738 0.249036 10.5811 0.555703L17.4441 7.4187C17.7508 7.72537 17.9041 8.1067 17.9041 8.5627C17.9041 9.0187 17.7508 9.3997 17.4441 9.7057L16.2891 10.8617C15.9824 11.1684 15.6001 11.3217 15.1421 11.3217C14.6841 11.3217 14.3021 11.1684 13.9961 10.8617L12.1581 9.0167L9.02309 12.1517L10.8671 13.9957C11.1738 14.3024 11.3271 14.6837 11.3271 15.1397C11.3271 15.5957 11.1738 15.9767 10.8671 16.2827L9.71109 17.4187Z" fill="#E33A34"/>
                                              </svg>
                                            </div>
                                            <div className="m-t-2" style={{alignSelf:"flex-start"}}>
                                              <p className="fs-15 font-weight-600" style={{lineHeight:"15px"}}>{exercises.additionalContentDetails && exercises.additionalContentDetails.exerciseName ? exercises.additionalContentDetails.exerciseName : ""}</p>
                                              <p className="fs-12">Unit - {exercises.additionalContentDetails && exercises.additionalContentDetails.unit ? exercises.additionalContentDetails.unit : ""}</p>
                                            </div>
                                          </div>
                                        )
                                      })
                                    }
                                  </div>
                                )
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  ),

                  isFitnessPlannerLoader && <div className="loader-5 center"><span></span></div>

                ]
              }

              {
                fitnessTest.goal.goalDisplayName && [ 
                  <svg className="flex-item m-t-20" width="100%" height="2" viewBox="0 0 362 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line y1="0.5" x2="362" y2="0.5" stroke="#949494" stroke-dasharray="4 4"/>
                  </svg>,
                  <p className="flex-item m-t-16 fs-18 font-weight-600 color-dark-blue">{fitnessTest.goal.goalDisplayName}</p>,
                  <div className="d-flex m-t-4">
                    <p className="flex-item m-r-12 fs-14">Is Fitness Goal Achieved ?</p>
                    <div onClick={toggleGoalAchievement} className='toggle-button d-flex cursor-pointer' style={{backgroundColor: fitnessTest.goalAchieved && "#B3E28F"}}>
                      <div className='toggle-ball flex-item' style={{right: fitnessTest.goalAchieved && 0, left: fitnessTest.goalAchieved && "auto", backgroundColor: fitnessTest.goalAchieved && "#5d883c"}} />
                    </div>
                  </div>
                ]
              }

            </div>

           
            <div onClick={isButtonLock == false && SaveFitnessTestReport} className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
              <div className={`global-button-container ${isButtonLock == true ? "member-button-global-inactive" : "global-button-container-active"} d-flex flex-item`} style={{borderRadius:"20px", height:"40px"}}>
                <p className="flex-item">Mark Report</p>
              </div>
            </div>
            </>
          )
        }
      </div>
    </div>
  )
}

export default FitnessTest;
